import React, { useState } from 'react';
import { FAQS } from '../utils/constants';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="py-20 px-4 bg-gray-50" data-id="element-59">
      <div className="container mx-auto max-w-3xl" data-id="element-60">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-61">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-62">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-63">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-64">
                  <span className="font-bold text-gray-900 text-lg pr-8" data-id="element-65">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-6 h-6 text-gray-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-66" />
                </button>

                <AnimatePresence data-id="element-67">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-68">
                      <div className="px-6 pb-5 text-gray-700 leading-relaxed border-t border-gray-100 pt-4" data-id="element-69">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};